import { contentItems, collections, heroSlides } from '@/mocks/content';
import type { ContentItem } from '@/types/content';

export const allContent: ContentItem[] = contentItems as unknown as ContentItem[];
export const allCollections = collections;
export const allHeroSlides = heroSlides;

export const movies = allContent.filter((item) => item.type === 'movie');
export const tvshows = allContent.filter((item) => item.type === 'tvshow');
export const news = allContent.filter((item) => item.type === 'news');

export function getContentById(id?: string): ContentItem | undefined {
  if (!id) return undefined;
  return allContent.find((item) => item.id === id);
}

export function getRelated(item: ContentItem, limit = 4): ContentItem[] {
  const sameType = allContent.filter(
    (entry) => entry.id !== item.id && entry.type === item.type,
  );
  const scored = sameType
    .map((entry) => {
      const overlap = entry.genre.filter((genre) => item.genre.includes(genre)).length;
      const sameCategory =
        entry.articleCategory && entry.articleCategory === item.articleCategory ? 1 : 0;
      return { entry, score: overlap * 2 + sameCategory };
    })
    .sort((a, b) => b.score - a.score);
  return scored.slice(0, limit).map((entry) => entry.entry);
}

export function collectGenres(items: ContentItem[]): string[] {
  const set = new Set<string>();
  items.forEach((item) => item.genre.forEach((genre) => set.add(genre)));
  return Array.from(set);
}

export function collectRegions(items: ContentItem[]): string[] {
  const set = new Set<string>();
  items.forEach((item) => set.add(item.region));
  return Array.from(set);
}

export function collectYears(items: ContentItem[]): number[] {
  const set = new Set<number>();
  items.forEach((item) => set.add(item.year));
  return Array.from(set).sort((a, b) => b - a);
}